module.exports = __webpack_public_path__ + "static/media/monitor-fill.4b3072ea.svg";